const { validateContract } = require('./approval-contract')
const { toCents, files } = require('./expense')
const { invoiceLines } = require('./invoice-content')
const LABELS = { PAYMENT: '付款申请', LOAN: '借款申请', INVOICE: '开票申请' }
const STATUS = { 0: '草稿', 10: '审批 / 办理中', 20: '已驳回', 30: '已付款，待补发票', 40: '待总账确认发票', 50: '已办结', 60: '已撤回' }
const target = type => ({ PAYMENT: 'paymentApplication', LOAN: 'loanApplication', INVOICE: 'invoiceApplication' }[type])
function total(lines) { return ((lines || []).reduce((n, x) => n + toCents(x.amount || '0'), 0) / 100).toFixed(2) }
function validate(a, c, submitting, attachments) {
  if (!LABELS[a.applicationType]) throw Error('申请类型无效')
  if (!a.applicantId || !a.deptId) throw Error('请选择申请人和申请部门')
  if (!a.companyId) throw Error('请选择公司')
  validateContract(a.contractId, c.noContract, c.noContractReason, submitting)
  const required = (v, label) => { if (!String(v || '').trim()) throw Error('请填写' + label) }
  if (a.applicationType === 'PAYMENT') {
    a.amount = total(c.lines)
    if (submitting) {
      required(a.reason, '付款事由'); required(c.recipientName, '收款单位'); required(c.bankAccount, '银行账户'); required(c.bankName, '开户行')
      required(c.invoiceSituation, '发票情况'); required(c.paymentMethod, '付款方式')
      if (!(c.lines || []).length) throw Error('请添加付款明细')
      c.lines.forEach((x, i) => { required(x.paymentType, '第' + (i + 1) + '条付款类型'); if (!toCents(x.amount || '0')) throw Error('付款明细金额须大于0') })
    }
  } else if (submitting && a.applicationType === 'LOAN') {
    required(a.reason, '借款事由'); if (!(attachments || []).length) throw Error('借款申请须上传附件')
  } else if (submitting) {
    required(c.buyerName, '购买单位名称'); required(c.invoiceType, '票据类型'); required(c.invoiceInformation, '开票信息')
    invoiceLines(c).forEach((line,index) => { required(line.goodsName, '第' + (index+1) + '项货物名称'); if (line.quantity != null && line.quantity !== '' && (!/^\d+(\.\d{1,4})?$/.test(String(line.quantity)) || Number(line.quantity)<=0 || Number(line.quantity)>999999999)) throw Error('货物数量须为正数且最多4位小数') })
  }
  const amount = toCents(a.amount || '0')
  if (submitting && !amount) throw Error('申请金额须大于0')
}
function payload(a, c, attachments, images) {
  const application = {}
  ;['id','revision','applicationType','applicantId','deptId','companyId','contractId','budgetType','containsLaborMaterial','reason','amount','relatedWorkOrderId'].forEach(k => { if (a[k] !== undefined) application[k] = a[k] })
  application.contractId = a.contractId || null
  if (application.relatedWorkOrderId === '') application.relatedWorkOrderId = null
  application.fileObjs = JSON.stringify(attachments || files(a.fileObjs)); application.imageObjs = JSON.stringify(images || files(a.imageObjs))
  const content = { ...c, quantity: c.quantity === '' ? null : c.quantity, ...(a.applicationType === 'INVOICE' ? { invoiceLines: invoiceLines(c).map(x => ({...x, quantity: x.quantity === '' ? null : x.quantity})) } : {}) }
  return { application, content }
}
module.exports = { LABELS, STATUS, target, total, validate, payload }
